import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseApi } from '../BaseApi';
import { query as getOrderQuery } from '../../graphql/getOrder.graphql';
import { query as getOrderForTYPQuery } from '../../graphql/getOrderForTYP.graphql';
import { query as getOrderForTYPOldQuery } from '../../graphql/getOrderForTYPOld.graphql';
import { query as getOrderForTYPNoModifiersQuery } from '../../graphql/getOrderForTYP.noModifiers.graphql';
import { query as getOrderForTYPOldNoModifiersQuery } from '../../graphql/getOrderForTYPOld.noModifiers.graphql';
import { GraphQLOperations, RemoteSourceTypes } from '../constants';
import { SPECS } from '../../constants';
var OrdersApi = /** @class */ (function (_super) {
    __extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrdersApi.prototype.doFetch = function (query, variables, operationName) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: variables,
                            query: query,
                            operationName: operationName,
                        }, RemoteSourceTypes.NodeReadWriteForcePlatform, true)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    OrdersApi.prototype.fetchOrder = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doFetch(getOrderQuery, variables, GraphQLOperations.GetOrder)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.order];
                }
            });
        });
    };
    OrdersApi.prototype.fetchOrderForTYP = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var variablesWithOrigin, shouldAddProjectionsTYPQuery, shouldAddModifiers, promise, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variablesWithOrigin = __assign(__assign({}, variables), { origin: 'thankYouPage' });
                        shouldAddProjectionsTYPQuery = this.siteStore.experiments.enabled(SPECS.AddProjectionsTYPQuery);
                        shouldAddModifiers = this.siteStore.experiments.enabled(SPECS.OrdersModifiers);
                        /* istanbul ignore if */
                        if (!shouldAddModifiers) {
                            promise = shouldAddProjectionsTYPQuery
                                ? this.doFetch(getOrderForTYPNoModifiersQuery, variablesWithOrigin, GraphQLOperations.GetOrderForTYPNoModifiers)
                                : this.doFetch(getOrderForTYPOldNoModifiersQuery, variablesWithOrigin, GraphQLOperations.GetOrderForTYPOldNoModifiers);
                            /* istanbul ignore next */
                            return [2 /*return*/, promise.then(function (data) { return data.order; })];
                        }
                        return [4 /*yield*/, (shouldAddProjectionsTYPQuery
                                ? this.doFetch(getOrderForTYPQuery, variablesWithOrigin, GraphQLOperations.GetOrderForTYP)
                                : /* istanbul ignore next */ this.doFetch(getOrderForTYPOldQuery, variablesWithOrigin, GraphQLOperations.GetOrderForTYPOld))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.order];
                }
            });
        });
    };
    return OrdersApi;
}(BaseApi));
export { OrdersApi };
//# sourceMappingURL=OrdersApi.js.map